export default __webpack_public_path__ + "static/media/contact.a38d2358.jpg";